<template  >
  <!--My_learing Section 06 -->
  <div class="course_discription">
    <section class>
      <div class="container">
        <div class="container">
          <div class="">
            <div class="hero-textn">
              <h2>{{ $root.Mycourse.text }}</h2>
            </div>
          </div>
        </div>
      </div>
      <div class="hero-image">
        <img class src="/assets/exported/my_course.jpg" alt />
      </div>
    </section>
    <section>
      <div class="container course_hero">
        <div class="container">
          <div class="course_d_list">
            <h1>{{ profile_name }}</h1>
            <div class="sub_reg login-section zoom">
              <router-link
                to="/edit_profile"
                class="profile_name"
                style="color: #fff"
                >{{ $root.Mycourse_pro.text_pro }}</router-link
              >
            </div>
          </div>
          <div class="spinnerdes" v-if="isLoading">
            <div class="dot1"></div>
            <div class="dot2"></div>
          </div>
          <div v-for="data in my_courses" v-bind:key="data.id">
            <div class="learning_d_list">
              <h2>{{ data.course.name }}</h2>
            </div>

            <div class="learning_d_list">
              <h3>{{ $root.model.text_model }}</h3>
              <div class="container">
                <div class>
                  <div class="row_rg course_d_p course_md">
                    <div class="learing_list_head_1">
                      <div class="row_rg learing_d">
                        <div class="column">
                          <div>
                            <b>{{ $root.model_course.text_model_c }}</b>
                          </div>
                        </div>
                        <div class style="padding: 0px 0px 0px 5px">
                          <div class="course_md_time_1">
                            <b class="time_c_t">{{
                              $root.model_date.text_model_d
                            }}</b>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      v-for="mod in data.course.course_modules"
                      v-bind:key="mod.id"
                      class="learning_modulas"
                    >
                      <div class="column course_list_body_mod">
                        <div for="uname" class="my_learn_mudules_text_bold">
                          <a>{{ mod.title }}</a>
                        </div>
                      </div>
                      <div>
                        <div class="loading-bar">
                          <div
                            class="learning_percent percent"
                            :style="{
                              width: mod.module_progress.percent_int + '%',
                            }"
                          >
                            {{ mod.module_progress.complete_percent }}%
                          </div>
                          <div
                            class="percentage"
                            :style="{
                              width: mod.module_progress.percent_int + '%',
                            }"
                          ></div>
                        </div>
                        <div
                          class="course_list_body_mod_right"
                          style="padding: 0px 0px 0px 5px"
                        >
                          <div class>
                            <a>{{ mod.module_progress.last_date }}</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                v-if="showCertificate == true"
                class="container login-section certificate_button_show"
              >
                <h1>
                  কৈশোরকালীন পুষ্টি কার্যক্রম কোর্সটি সফলভাবে সম্পন্ন করেছে
                </h1>
                <router-link to="/certificate">
                  <button type="submit">সনদপত্র</button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>


<script>
import axios from "axios";
export default {
  data: () => {
    return {
      profile_name: "",
      percentage: 0,
      my_courses: [],
      showCertificate: false,
      isLoading: true,
    };
  },
  methods: {
    reloadAPI() {
      // Get Data From Offline
      if (!navigator.onLine) {
        this.isLoading = false;
        if (window.localStorage.getItem("get-my-course") != null) {
          console.log("Local Data: get-my-course");
          var localData = JSON.parse(
            window.localStorage.getItem("get-my-course")
          );

          var empty_array = {
            complete_percent: "0",
            id: 0,
            last_date: "",
            percent_int: 0,
          };
          var response_data = [];
          response_data = localData;

          for (var i = 0; i < response_data.length; i++) {
            for (
              var j = 0;
              j < response_data[i].course.course_modules.length;
              j++
            ) {
              if (
                response_data[i].course.course_modules[j].module_progress ==
                null
              ) {
                response_data[i].course.course_modules[
                  j
                ].module_progress = empty_array;
              }
            }
          }

          this.my_courses = response_data;
          return;
        }
      }
      var user_profile = JSON.parse(window.localStorage.getItem("profile"));
      this.profile_name = user_profile.data.name;
      var config = {
        headers: {
          "X-localization": this.$root.translate ? "bn" : "en",
          Authorization: "bearer " + user_profile.token,
        },
      };
      axios.get(this.$root.API_BASE_URL + "get-my-course", config)
      .then((response) => {
        // Response received From Server
        this.isLoading = false;

        if (response.data == []) {
          // Blank
          return;
        }
        // Save Locally
        localStorage.setItem(
          "get-my-course",
          JSON.stringify(response.data.data)
        );
        var empty_array = {
          complete_percent: "0",
          id: 0,
          last_date: "",
          percent_int: 0,
        };
        var response_data = [];
        response_data = response.data.data;

        for (var i = 0; i < response_data.length; i++) {
          for (
            var j = 0;
            j < response_data[i].course.course_modules.length;
            j++
          ) {
            if (
              response_data[i].course.course_modules[j].module_progress ==
              null
            ) {
              response_data[i].course.course_modules[
                j
              ].module_progress = empty_array;
            }
          }
        }

        this.my_courses = response_data;

        if (this.$root.getLocalValue("review_done") == "true") {
          this.showCertificate = true;
        }
      });
      axios.get(this.$root.API_BASE_URL + "certificate-check?course_id=7", config)
      .then((response) => {
        if(response.data != null){
          if(response.data.status != null){
            if(response.data.status ==  true){
              this.showCertificate = true;
              this.$root.setLocalValue("review_done", "true");
            }
          }
        }
      });
    },
  },
  computed: {
    percent() {
      return this.percentage.toFixed();
    },
  },
  mounted() {
    this.reloadAPI();
    this.$root.page_hook = this;
  },
  beforeMount() {
    this.$root.syncOnline();
  },
  beforeDestroy() {
    this.$root.page_hook = null;
  },
  created() {
    var intval = setInterval(() => {
      if (this.percentage < 60) this.percentage += 0.1;
      else clearInterval(intval);
    }, 10);
  },
};
</script>

<style scoped>
.course_md_time_1 {
  float: right;
}

.my_learn_mudules_text_bold {
  font-weight: 600;
}
.learing_list_head_1 {
  background: #e9e9e9 0% 0% no-repeat padding-box;
  opacity: 1;
  margin-top: 20px;
}
.profile_name {
  background: transparent linear-gradient(264deg, #8fc15a 0%, #005a06 100%) 0%
    0% no-repeat padding-box;
  -webkit-box-shadow: 0px 2px 3px #00000087;
  box-shadow: 0px 2px 3px #00000087;
  padding: 10px 40px;
  border-radius: 6px;
  color: #fff;
  font-weight: 600;
}
.course_d_p {
  margin-left: -10px;
  padding: 10px 0px;
  width: 100%;
}
@media screen and (max-width: 1200px) {
}
@media screen and (max-width: 991px) {
}

@media screen and (max-width: 768px) {
  .course_d_p {
    margin-left: -10px;
    padding: 10px 0px;
    width: 102%;
  }
  .time_c_t {
    margin-left: -5px;
  }
}
@media screen and (max-width: 480px) {
  .learing_d b {
    font-size: 16px;
    font-weight: 600;
    padding-left: 2px;
  }
  .time_c_t {
    margin-left: -10px;
  }
  .course_d_p {
    margin-left: -10px;
    padding: 10px 0px;
    width: 105%;
  }
}

@media screen and (max-width: 400px) {
  .course_d_p {
    margin-left: -15px;
    padding: 10px 0px;
    width: 110%;
  }
}
@media screen and (max-width: 340px) {
  .course_d_p {
    margin-left: -15px;
    padding: 10px 0px;
    width: 113%;
  }
  .learing_d b {
    padding-left: 0px;
  }
  .loading-bar {
    width: 65%;
  }
}
</style>